import { useEffect, useState } from 'react';

/**
 * DIE SUCHE NACH DEN SCHLÜSSELN, ÜBERALL IN DER ABRECHNUNG GLEICH (.300).
 *
 * ORIGINALTEXT MARVIN (04.10.2026, Bild der Gebühren)
 *   „Ich möchte hier nach KLS-ID, SM, adresse suchen können, das gleiche auch
 *    bei alles anderen bereichen der abrechnung, diese felder musst du noch
 *    einbauen, auch das man dann sich alle anzeigen lassen kann, auch
 *    bezahlt, freigebene usw. das ist wichtig, das sind schlüsselvariablen
 *    mit denen wir überall arbeiten, so wie bei der auftragssuche"
 *
 * Ein Feld, eine Aufschrift, eine Regel. Wo die Liste ganz im Browser liegt,
 * prüft `passtSuche` hier; wo der Server filtert, geht der Text an denselben
 * Weg wie die Auftragssuche (`regeln/auftragsuche.ts`). WER SUCHT, SUCHT IN
 * ALLEN ZUSTÄNDEN: offen, freigegeben, bezahlt. Der Zustand steht dann an
 * jeder Zeile.
 */

/** Klein, ohne Punkte, „straße" wie „str", Leerzeichen einfach. */
export function normSuche(s: unknown): string {
  return String(s ?? '').toLowerCase()
    .replace(/stra(ß|ss)e\b/g, 'str').replace(/\bstr\.?/g, 'str')
    .replace(/[.]/g, '').replace(/\s+/g, ' ').trim();
}

/** Passt die Suche zu einem der Werte? Leere Suche passt immer. */
export function passtSuche(suche: string, ...werte: unknown[]): boolean {
  const s = normSuche(suche);
  if (!s) return true;
  const ohneLeer = s.replace(/\s/g, '');
  return werte.some((w) => {
    const n = normSuche(w);
    return n.includes(s) || (ohneLeer.length >= 4 && n.replace(/\s/g, '').includes(ohneLeer));
  });
}

/** Die Anschrift einer Zeile in einem Stück, für `passtSuche`. */
export function anschriftVon(z: any): string {
  return [z?.strasse, [z?.hausnummer, z?.hausnummer_zusatz].filter(Boolean).join(''),
          z?.plz, z?.ort_text ?? z?.ort].filter(Boolean).join(' ');
}

export const SUCHE_TEXT = 'KLS-ID, SM, Adresse';

/** Das Suchfeld. `mehr` ergänzt die Aufschrift (z. B. „Kassenzeichen"). */
export function Suchfeld({ wert, setze, mehr, breit }: {
  wert: string; setze: (s: string) => void; mehr?: string; breit?: number;
}) {
  /* DAS X ZUM LEEREN (.538). Marvin (28.10.2026, iPhone): „Beim Suchen gibt es
     kein X zum Zurücksetzen. Da muss ich immer mit der Maus klicken." Das
     Telefon zeigt das eingebaute X des Suchfelds nicht; also ein eigenes,
     das immer da ist, sobald etwas drinsteht. */
  return (
    <span className="suchfeld-huelle" style={{ minWidth: breit ?? 260 }}>
      <input className="suche" type="search" autoComplete="off" value={wert}
             placeholder={`Suchen: ${SUCHE_TEXT}${mehr ? ', ' + mehr : ''} …`}
             title="Sucht in allen Zuständen, auch bezahlt und freigegeben"
             onChange={(e) => setze(e.target.value)} />
      {wert !== '' && (
        <button type="button" className="suchfeld-leeren" aria-label="Suche leeren" title="Suche leeren" onClick={() => setze('')}>×</button>
      )}
    </span>
  );
}

/** Ein Wert, der erst nach einer Tippause weitergegeben wird (für Server-Suchen). */
export function useVerzoegert<T>(wert: T, ms = 350): T {
  const [v, setV] = useState(wert);
  useEffect(() => { const t = setTimeout(() => setV(wert), ms); return () => clearTimeout(t); }, [wert, ms]);
  return v;
}

/** Der Hinweis über einer Trefferliste. */
export function SuchHinweis({ suche, n }: { suche: string; n: number }) {
  if (!suche.trim()) return null;
  return (
    <div className="hinweis klein" style={{ marginBottom: 8 }}>
      {n} Treffer für „{suche.trim()}" in allen Zuständen (offen, freigegeben, bezahlt).
    </div>
  );
}
